import First from "./components/introduction/introduction";
import Third from "./components/works/works";
import Fourth from "./components/fourth/fourth";
import Five from "./components/five/five";
import Six from "./components/six/six";
import Launch from "./components/launch/launch";
import { Box } from "@mui/material";

const Home = () => {
    return (
        <Box style={{ backgroundColor: 'white' }}>
            <First />
            <Third />
            <Fourth />
            <Five />
            <Six />
            <Launch />
        </Box>
    );
};

export default Home;
